<template>
  <v-list-item :key="surveyTemplate.id" class="grey lighten-4 my-2" link @click="goToSurveyTemplate">
    <v-list-item-avatar :color="surveyTemplate.active ? `success lighten-4` : `grey lighten-4`">
      <v-icon v-if="loading">mdi mdi-loading mdi-spin</v-icon>
      <v-icon v-else-if="!surveyTemplate.active">mdi mdi-checkbox-blank-circle-outline</v-icon>
      <v-icon v-else>mdi mdi-check</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{
          $t('surveys.type.' + surveyTemplate.type)
        }}
      </v-list-item-title>
      <v-list-item-subtitle>{{ $formatDateTime(surveyTemplate.createdAt) }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs"
                 v-on="on">
            <v-icon>mdi mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item color="default" link @click="cloneSurveyTemplate">
            <v-list-item-icon>
              <v-icon>mdi mdi-content-duplicate</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>
              {{ $t('questions.duplicate') }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item color="default" link @click="activateSurveyTemplate">
            <v-list-item-icon>
              <v-icon>mdi mdi-check</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>
              {{ $t('survey_templates.activate') }}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>

      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import surveyTemplateApi from "@/api/surveytemplate";

export default {
  name: "SurveyTemplateItem",
  data() {
    return {
      loading: false,
    }
  },
  props: {
    surveyTemplate: Object
  },
  methods: {
    /*async cloneSurveyTemplate() {
      const idx = this.surveytemplates.findIndex(s => s.key === surveyTemplate.key);
      if (idx > -1) {
        this.$set(this.surveytemplates, `${idx}`, {...surveyTemplate, _loading: true})
      }
      await surveyTemplateApi.cloneSurveyTemplate(surveyTemplate)
      if (idx > -1) {
        this.$set(this.surveytemplates, `${idx}`, {...surveyTemplate, _loading: false})
      }
    },*/
    async cloneSurveyTemplate() {
      this.loading = true;
      try {
        await surveyTemplateApi.cloneSurveyTemplate(this.surveyTemplate);
        this.$showSuccessNotification(this.$t('survey_template.messages.cloned'))
      } catch (e) {
        this.$handleApiError(e, this.$t('survey_templates.errors.error_cloning'))
      }
      this.$emit('reload')
      this.loading = false;
    },
    async activateSurveyTemplate() {
      this.loading = true;
      try {
        await surveyTemplateApi.activateSurveyTemplate(this.surveyTemplate);
        this.$showSuccessNotification(this.$t('survey_template.messages.activated'))
      } catch (e) {
        this.$handleApiError(e, this.$t('survey_templates.errors.error_activating'))
      }
      this.$emit('reload')
      this.loading = false;
    },
    goToSurveyTemplate() {
      this.$router.push({name: 'edit_survey_template', params: {key: this.surveyTemplate.key}})
    }
  }
}
</script>

<style scoped>

</style>
